import { atom } from "recoil";

export const backendDataAtom = atom({
  key: "backendDataState",
  default: { type: "none", data: undefined, id: undefined },
});
